/* Dravella bilingue (10/10/2026) : bandeau d'offre + noms de remise dans la langue de la page.
   Remplace dvl-cart-en.js. EN = dravella.com, ES = dravella.com/es (lang de <html>). */
(() => {
  const ES = (document.documentElement.lang || "").toLowerCase().indexOf("es") === 0;
  const ID = "dvl-offer-bar";
  const BANNER = ES
    ? '<div class="svcb"><span class="svcb__t"><b>Últimas horas</b> &middot; la oferta termina esta noche</span></div>'
    : '<div class="svcb"><span class="svcb__t"><b>Final hours</b> &middot; the offer ends tonight</span></div>';

  async function paint() {
    let cart;
    try { cart = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart.js").then((r) => r.json()); } catch (e) { return; }
    document.querySelectorAll("#" + ID).forEach((n) => n.remove());
    document.querySelectorAll("#dvl-cart-usp").forEach((n) => n.remove());
    if (cart.item_count === 0) return;
    const host =
      document.querySelector("cart-drawer .drawer__inner") ||
      document.querySelector(".cart__items") ||
      document.querySelector("#main-cart-items");
    if (!host) return;
    const el = document.createElement("div");
    el.id = ID;
    el.innerHTML = BANNER;
    /* ordre impose (28/09) : timer de reservation, puis bandeau d'offre */
    const timer  = host.querySelector(".elora-rsv");
    const header = host.querySelector(".drawer__header");
    if (timer) timer.after(el);
    else if (header) header.after(el);
    else host.prepend(el);
  }

  const later = () => setTimeout(paint, 120);
  document.addEventListener("DOMContentLoaded", later);
  if (document.readyState !== "loading") later();
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, later);
  }
  const watch = () => {
    const d = document.querySelector("cart-drawer") || document.querySelector("#main-cart-items");
    if (!d) return setTimeout(watch, 500);
    new MutationObserver(() => {
      if (!document.getElementById(ID)) later();
      const t = document.querySelector(".elora-rsv"), b = document.getElementById(ID);
      if (t && b && t.nextElementSibling !== b) t.after(b);
    }).observe(d, { childList: true, subtree: true });
    later();
  };
  watch();
})();
